export default __webpack_public_path__ + "static/media/appIcon.b805402d.svg";